<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Add IP Blacklist</h2>
          </div>
          <div class="body">
            <form @submit.prevent="DataSubmit" id="basic-form">
              <div class="body">
                <div class="add-ip-add form-group d-flex align-items-center">
                  <label for="ipaddress" class="control-label mr-3 mb-0">
                    Add IP address
                  </label>
                  <span
                    class="ip-input-box d-flex justify-content-between align-items-center"
                  >
                    <input
                      type="text"
                      v-model="ipaddress1"
                      maxlength="3"
                      @keydown="clearIpAddress($event)"
                      @keypress="onlyNumber($event)"
                      @paste="pasteIpAddress($event)"
                      class="form-control"
                    />
                    <span class="font-weight-bold">.</span>
                    <input
                      type="text"
                      v-model="ipaddress2"
                      maxlength="3"
                      @keydown="clearIpAddress($event)"
                      @keypress="onlyNumber($event)"
                      @paste="pasteIpAddress($event)"
                      class="form-control"
                    />
                    <span class="font-weight-bold">.</span>
                    <input
                      type="text"
                      v-model="ipaddress3"
                      maxlength="3"
                      @keydown="clearIpAddress($event)"
                      @keypress="onlyNumber($event)"
                      @paste="pasteIpAddress($event)"
                      class="form-control"
                    />
                    <span class="font-weight-bold">.</span>
                    <input
                      type="text"
                      v-model="ipaddress4"
                      maxlength="3"
                      @keydown="clearIpAddress($event)"
                      @keypress="onlyNumber($event)"
                      @paste="pasteIpAddress($event)"
                      class="form-control"
                    />
                  </span>
                  <span v-if="!ipaddressValidate" class="text-danger ml-1">
                    Ip address field Is Required
                  </span>
                </div>
                <div class="country-dropdown">
                  <div class="form-group form-select multiselect-grp mb-0">
                    <span class="float-label">
                      <label for="Country">Select Customer</label>
                      <v-select
                        :options="options"
                        multiple
                        v-model="customers"
                        @search="searchCustomer"
                        @option:selected="selectCustomer"
                      ></v-select>
                    </span>
                  </div>
                  <span v-if="!customerValidate" class="text-danger">
                    Please select customer
                  </span>
                </div>
              </div>
              <div
                class="d-flex flex-column flex-md-row justify-content-center"
              >
                <b-button
                  variant="secondary btn-mw"
                  size="lg"
                  @click="$router.back()"
                >
                  Cancel
                </b-button>
                <b-button
                  type="submit"
                  variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                  size="lg"
                >
                  Submit
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
import "@/plugins/vee-validate";
import select from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapState, mapGetters } from "vuex";
export default {
  name: "AddCustomerIPBlacklist",
  components: {
    BreadCrumb,
    "v-select": select,
  },
  data() {
    return {
      ipaddress1: "",
      ipaddress2: "",
      ipaddress3: "",
      ipaddress4: "",
      customers: [],
      ipaddressValidate: true,
      customerValidate: true,
      options: [],
      breadCrumbIteams: [
        {
          title: "Customer",
          links: "",
        },
        {
          title: "Customer IP Blacklist",
          links: "",
        },
        {
          title: "Add",
          links: "",
        },
      ],
    };
  },
  methods: {
    pasteIpAddress($event) {
      const pastedData = $event.clipboardData.getData("text");
      const ipPattern =
        /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\.((25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})$/;
      this.isValid = ipPattern.test(pastedData);
      if (this.isValid) {
        const temp = pastedData.split(":")[0];
        this.ipaddress1 = temp.split(".")[0];
        this.ipaddress2 = temp.split(".")[1];
        this.ipaddress3 = temp.split(".")[2];
        this.ipaddress4 = temp.split(".")[3];
      }
    },
    searchCustomer() {
      this.options = [
        "Robert Evans",
        "Selena Parker",
        "Mark Chalamet",
        "Dominic Torreto",
        "Emma Thomas",
        "Alizee Thomas",
        "Adam Driver",
        "Brain O'Conner",
      ];
    },
    selectCustomer() {
      setTimeout(() => {
        this.options = [];
      }, 100);
    },
    focusnext($event) {
      console.log($event.target);
    },
    DataSubmit() {
      if (this.customers.length == 0) {
        this.customerValidate = false;
      } else {
        this.customerValidate = true;
      }
      if (
        !this.ipaddress1 ||
        !this.ipaddress2 ||
        !this.ipaddress3 ||
        !this.ipaddress4
      ) {
        this.ipaddressValidate = false;
      } else {
        this.ipaddressValidate = true;
      }

      if (this.customerValidate || this.ipaddressValidate) {
        this.customerValidate = true;
        this.ipaddressValidate = true;
        console.log("submit");
      }
    },
    clearIpAddress($event) {
      setTimeout(() => {
        if ($event.target.value.length == 0) {
          $event.target?.previousElementSibling?.previousElementSibling.focus();
        }
      }, 100);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
      setTimeout(() => {
        if ($event.target.value.length > 2) {
          $event.target?.nextElementSibling?.nextElementSibling.focus();
        }
      }, 100);
    },
  },
  mounted() {
    //
  },
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
